import React, { Component } from 'react'
import { Auth } from 'aws-amplify'
import Button from 'antd/lib/button'
import Form from 'antd/lib/form'
import Select from 'antd/lib/select'
import Input from 'antd/lib/input'
import PhoneInput from 'react-phone-number-input'
import { setErrorMessage, showConfirmationForm, showForm, setShowPopUp } from '../../../redux/auth/actions'
import ExtraOccupancies from './ExtraOccupancies'
import '../../../styles/PhoneInput.css'

const Option = Select.Option

const styles = {
    infoContainer: {
        margin: '1em 0 1em 0',
        display: 'flex',
        justifyContent: 'space-around',
    },
    infoType: {
        color: '#000',
    },
    button: {
        backgroundColor: '#1BAAF1',
        borderColor: '#1BAAF1',
    },
    submitButton: {
        float: 'right',
        backgroundColor: '#1BAAF1',
        borderColor: '#1BAAF1',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
}

class AdditionalRegistrationForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            attr: {}
        }
    }


    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { work_phone, mobile_phone, suite, floor } = values

                let attributes = this.props.attributes
                let password = attributes.password
                delete attributes.password

                if (suite) attributes['custom:suite'] = `${suite}`
                attributes['custom:floor'] = `${floor}`
                if (work_phone != null) attributes['custom:work_landline'] = work_phone
                if (mobile_phone != null) attributes.phone_number = mobile_phone

                Object.keys(values).map(key => {
                    if (key.split("-")[0] === 'field' && values[key] !== undefined) {
                        attributes[`custom:field${key.split("-")[1]}`] = `${key.split('-')[2]}#${values[key]}`
                    }
                })

                Auth.signUp({
                    username: attributes.email,
                    password,
                    attributes: attributes,
                }).then((res) => {
                    showConfirmationForm(attributes.email)
                }).catch((err) => {
                    console.log('error: ', err)
                    if (err.code === 'UsernameExistsException') {
                        setShowPopUp(true)
                        this.setState({attr: attributes})
                    } else {
                        setErrorMessage(err.message)
                    }
                })
            }
        })
    }

    changePhone(e) {
        console.log(e)
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { floors, suites, settings } = this.props

        const formItemLayout = {
            labelCol: {
                xs: { span: 32 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 32 },
                sm: { span: 16 },
            },
        }
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        }

        console.log("settings: ", settings)

        return (
            <>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    {suites && (
                        <Form.Item label="Suite">
                            {getFieldDecorator('suite', {
                                initialValue: suites[0],
                                rules: [{ required: true, message: 'Please input your Suite' }],
                            })(
                                <Select style={{ width: '100%' }}>
                                    {suites.map((suite) => (
                                        <Option key={suite} value={suite}>{`Suite ${suite}`}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    )}
                    <Form.Item label="Floor">
                        {getFieldDecorator('floor', {
                            initialValue: floors[0],
                            rules: [{ required: true, message: 'Please input your Floor' }],
                        })(
                            <Select style={{ width: '100%' }}>
                                {floors.map((floor) => (
                                    <Option key={floor} value={floor}>{`${floor}`}</Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                    {settings?.fields?.map((field, index) => (
                        <Form.Item key={field.label} label={field.label}>
                            {getFieldDecorator(`field-${index + 1}-${field.label}`, {
                                rules: [{ required: field.required, message: `Please input your ${field.label}` }],
                            })(<Input />)}
                        </Form.Item>
                    ))}
                    <Form.Item label="Work Phone">
                        {getFieldDecorator('work_phone', {
                            rules: [{ required: settings?.workPhone, message: 'Please input your phone number!' }],
                        })(<PhoneInput defaultCountry="US" placeholder="Enter phone number" />)}
                    </Form.Item>
                    <Form.Item label="Mobile Phone">
                        {getFieldDecorator('mobile_phone', {
                            rules: [{ required: settings?.phone, message: 'Please input your phone number!' }],
                        })(<PhoneInput defaultCountry="US" placeholder="Enter mobile phone number" />)}
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout} >
                        <Button
                            onClick={showForm}
                            style={styles.button}
                            type="primary"
                            htmlType="button"
                        >
                            Back
                        </Button>
                        <Button style={styles.submitButton} type="primary" htmlType="submit">
                            Register
                        </Button>
                    </Form.Item>
                </Form>
                <ExtraOccupancies attr={this.state.attr} backToSignIn={this.props.backToSignIn} />
            </>
        )
    }
}

export default Form.create({ name: 'additionalRegister' })(AdditionalRegistrationForm)
